import React from "react";
import * as Icons from "lucide-react";
import { practiceAreas } from "../mock/mock";
import useReveal from "../hooks/useReveal";

const PracticeAreas = () => {
  const ref = useReveal();
  return (
    <section id="practice" className="py-24 bg-[#f7f5f0]">
      <div className="max-w-7xl mx-auto px-6" ref={ref}>
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-[#c8a15a] uppercase tracking-[0.3em] text-xs font-semibold mb-4">
            How I Can Help
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-[#14213d] mb-5">
            Areas of Practice
          </h2>
          <p className="text-slate-600 text-lg">
            Comprehensive legal services tailored to protect your rights, your
            family, and your future.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {practiceAreas.map((area, i) => {
            const Icon = Icons[area.icon] || Icons.Scale;
            return (
              <div
                key={area.title}
                className="reveal group bg-white rounded-xl p-7 border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300"
                style={{ animationDelay: `${i * 70}ms` }}
              >
                <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-[#14213d] text-[#c8a15a] mb-5 group-hover:bg-[#c8a15a] group-hover:text-[#14213d] transition-colors duration-300">
                  <Icon size={26} strokeWidth={1.8} />
                </div>
                <h3 className="font-display text-xl font-bold text-[#14213d] mb-2">
                  {area.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {area.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;
